var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',_vm._b({attrs:{"overlayClassName":"mpd-tooltip","getPopupContainer":_vm.getPopupContainer}},'a-tooltip',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }